module.exports = __webpack_public_path__ + "static/media/booth-bg.91a3433f.jpg";